import withLocalize, { IWithLocalizeOwnProps } from '@src/components/common/localize/withLocalize';
import { Divider, Layout, Typography } from 'antd';
import React from 'react';
import { Link } from 'react-router';

// -- Const
// ----------
const { Header } = Layout;

// -- Prop types
// ----------
export interface ISurveyInstanceNotifViewOwnProps {
}

type ISurveyInstanceNotifViewProps = ISurveyInstanceNotifViewOwnProps & IWithLocalizeOwnProps;

interface ISurveyInstanceNotifViewState {
}

// -- Component
// ----------
class SurveyInstanceNotifView extends React.Component<ISurveyInstanceNotifViewProps, ISurveyInstanceNotifViewState> {
  state: ISurveyInstanceNotifViewState = {
  };

  render() {
    return (
      <React.Fragment>
        <Layout className="panel  timun-examInstanceView__examContentTitle"> <Header>
          <Typography.Title> {this.props.translate('SURVEY_INSTANCE_NOTIFICATION_VIEW.SUCCESSFUL_SUBMIT')} </Typography.Title>
        </Header>
          <Divider />
          <Layout>
            <Typography.Title> {this.props.translate('SURVEY_INSTANCE_NOTIFICATION_VIEW.GRATITUDE_TEXT')}</Typography.Title>
            <Link to="/myprofile">{this.props.translate('SURVEY_INSTANCE_NOTIFICATION_VIEW.BACK_TO_MY_PROFILE_TEXT')}</Link>
          </Layout>
        </Layout>
      </React.Fragment>
    );
  }
}

// -- HOCs and exports
// ----------

export default withLocalize<ISurveyInstanceNotifViewOwnProps>(SurveyInstanceNotifView as any);
